import { Component, OnChanges, OnInit, SimpleChanges } from "@angular/core";
import { ActivatedRoute, NavigationEnd, Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { BehaviorSubject, filter, firstValueFrom, Observable } from "rxjs";


interface Breadcrumb {
  label: string;
  url?: string;
}
/***
 * BREADCRUMBS USADOS EN FASCICLE-EDIT
 */


@Component({
  selector: "top-breadcrumbs",
  templateUrl: "./top-breadcrumbs.component.html",
  styleUrls: ["./top-breadcrumbs.component.scss"],
})
export class TopBreadcrumbsComponent implements OnInit {
  private readonly _breadcrumbs$ = new BehaviorSubject<Breadcrumb[]>([]);

  readonly breadcrumbs$ = this._breadcrumbs$.asObservable();

  private test$!: Observable<any>;

  breadcrumbs: Breadcrumb[] = [];

  constructor (
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private translate: TranslateService
  ) {


  }

  ngOnInit(): void {
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.
    //        this.updateBreadCrumbs();
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => {
        this.updateBreadCrumbs();
      });

    // Inicializar breadcrumbs al cargar
    this.updateBreadCrumbs();
  }

  private updateBreadCrumbs(): void {
    let currentRoute = this.router.routerState.snapshot.root;

    // Navega hasta la ruta activa más interna
    while (currentRoute.firstChild) {
      currentRoute = currentRoute.firstChild;
    }

    // Accede a los datos resueltos desde el snapshot
    const data = currentRoute.data['breadcrumbs'];
    
    this.breadcrumbs = data || [];
    this._breadcrumbs$.next(this.breadcrumbs);
  }
}
